module.exports = __webpack_public_path__ + "media/images/locations/circle/spain-ca904850703e91fdb02b1d741fbed2a8.jpg";